import(/* webpackChunkName: "winInfoBox" */ '../Styles/winInfoBox.scss');

class WinInfoBox {
    constructor() {
        this.WinInfoBoxClass = '.win-info-box';
        this.WinInfoBoxIsEditorClass = `${this.WinInfoBoxClass}__is-editor`;
        this.WinInfoBoxLeftClass = `${this.WinInfoBoxClass}__left`;

        this.LinkButtonContainerClass = '.link-button-container';
    }

    init() {
        document.querySelectorAll(this.WinInfoBoxClass).forEach(parent => {
            if (parent.classList.contains(this.WinInfoBoxIsEditorClass.replace('.', ''))) {
                return;
            }

            const leftSide = parent.querySelector(this.WinInfoBoxLeftClass);
            if (leftSide) {
                this.lotteries = [];
                const lotteryNumbers = localStorage.getItem('lotteryNumbers');
                if (lotteryNumbers) {
                    let list = JSON.parse(lotteryNumbers);
                    list = list.filter(item => new Date(item.expire) > new Date());

                    this.lotteries = [...list];
                    localStorage.setItem('lotteryNumbers', JSON.stringify(this.lotteries));
                }

                const linkButton = leftSide.querySelector(this.LinkButtonContainerClass);
                if (this.lotteries.length == 0) {
                    linkButton.remove();
                } else {
                    linkButton.querySelector('.link-item').addEventListener('click', (event) => {
                        event.preventDefault();
                        document.querySelector('.lottery-number-input').scrollIntoView({ behavior: 'smooth', block: 'center' })
                    });
                }
            }
        });
    }
}

const winInfoBox = new WinInfoBox();
winInfoBox.init();